import {
  App,
  message as staticMessage,
  Modal as staticModal,
  notification as staticNotification,
} from "antd";
import type { MessageInstance } from "antd/es/message/interface";
import type { HookAPI as ModalHookAPI } from "antd/es/modal/useModal";
import type { NotificationInstance } from "antd/es/notification/interface";
import type React from "react";

// antd v6 起，从 antd 直接导入的静态 message / Modal.confirm / notification 无法消费
// ConfigProvider 的动态主题与语言，会在控制台告警：
//   "Static function can not consume context like dynamic theme. Please use App component instead."
// 解决方案：用挂在 <App> 内部的桥接组件，把 App.useApp() 拿到的带上下文实例注入到模块级变量，
// 供「非组件」代码（如 requestErrorConfig）和各页面统一调用 —— 既消除告警，又让主题/语言生效。
// 桥接挂载前（首帧之前）回退到 antd 静态方法，保证早期调用不会因实例未就绪而报错。

export let message: MessageInstance = staticMessage;
export let modal: ModalHookAPI = staticModal as unknown as ModalHookAPI;
export let notification: NotificationInstance = staticNotification;

/**
 * 挂在 <App> 内部（见 app.tsx 的 innerProvider），运行时把带上下文的
 * message / modal / notification 实例注入到本模块导出的变量。
 */
export const AntdStaticBridge: React.FC = () => {
  const app = App.useApp();
  message = app.message;
  modal = app.modal;
  notification = app.notification;
  return null;
};
